import React from 'react';
import ScratchpadApp from './ScratchpadApp';

export class App extends React.Component {
    render() {
        return (
            <>
                <ScratchpadApp/>
            </>
        );
    }
}

export default App;